import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

export const LegalPageLayout = ({ eyebrow, title, hatalyos, children }) => {
  return (
    <div data-testid="legal-page" className="bg-[#F8FAFC]">
      {/* Hero */}
      <section className="relative pt-28 md:pt-36 pb-12 md:pb-16 bg-gradient-to-br from-[#0B192C] via-[#102542] to-[#1E3E62] text-white overflow-hidden">
        <div className="absolute inset-0 opacity-[0.06] [background-image:radial-gradient(circle_at_1px_1px,#fff_1px,transparent_0)] [background-size:24px_24px]" />
        <div className="absolute -top-20 -right-10 w-72 h-72 rounded-full bg-[#EA580C]/15 blur-3xl" />
        <div className="relative max-w-4xl mx-auto px-4 md:px-8">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur border border-white/20 text-xs font-semibold tracking-widest uppercase"
          >
            <ShieldCheck className="w-3.5 h-3.5 text-[#EA580C]" />
            {eyebrow}
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-5 font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight"
          >
            {title}
          </motion.h1>
          {hatalyos && (
            <p className="mt-3 text-sm text-gray-300">
              Hatályos: <span className="text-white">{hatalyos}</span>
            </p>
          )}
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-20">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <article className="legal-prose bg-white rounded-lg shadow-sm border border-gray-100 p-6 md:p-12">
            {children}
          </article>
        </div>
      </section>
    </div>
  );
};

export default LegalPageLayout;
